export default {
  SUGGESTED_SEARCH: 'suggested-search',
  AUTO_COMPLETE: 'auto-complete',
  ENTER: 'enter'
};